import { useEffect, useState } from "react";
import { api } from "../lib/api";

type TagInfo = {
  merchant: { id: string; name: string; slug: string | null };
  wa_number: string;
  wa_text: string;
  tag_url: string;
  tag_token: string;
};

// Owner-facing printable "tap-to-punch" QR. Print this and stick it on the counter.
// A customer scanning the QR opens WhatsApp prefilled with PUNCH <token>; the bot
// validates the token against merchants.tag_token and direct-adds a punch.
export function Tag() {
  const [info, setInfo] = useState<TagInfo | null>(null);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    api<TagInfo>("/api/tag").then(setInfo).catch((e) => setErr(String(e)));
  }, []);

  if (err) {
    return (
      <div className="max-w-md mx-auto p-6 text-center text-red-600">{err}</div>
    );
  }
  if (!info) {
    return <div className="text-neutral-500 text-sm">Loading…</div>;
  }

  return (
    <div className="max-w-md mx-auto">
      <div className="text-sm text-neutral-500">Tap-to-punch QR</div>
      <h1 className="mt-1 text-2xl font-semibold">{info.merchant.name}</h1>
      <p className="mt-2 text-sm text-neutral-600">
        Print this and stick it on the counter. Customers scan with their camera, WhatsApp
        opens prefilled, and they get a punch as soon as they send the message.
      </p>

      <div className="mt-6 bg-white border border-neutral-200 rounded-xl p-6 flex flex-col items-center shadow-sm">
        <img
          src={`/qr/tag/${encodeURIComponent(info.tag_token)}`}
          alt="Tap-to-punch QR"
          className="w-72 h-72"
        />
        <div className="mt-4 text-xs uppercase tracking-widest text-neutral-400">scan to earn a punch</div>
        <div className="mt-1 font-mono text-sm">{info.wa_text}</div>
      </div>

      <div className="mt-4 text-xs text-neutral-500 break-all">
        Encoded link: <a className="underline" href={info.tag_url} target="_blank" rel="noreferrer">{info.tag_url}</a>
      </div>

      <div className="mt-6 flex gap-2 print:hidden">
        <button
          onClick={() => window.print()}
          className="px-3 py-2 rounded-md bg-punchy-500 text-white text-sm font-medium"
        >
          Print
        </button>
        <a
          href={`/qr/tag/${encodeURIComponent(info.tag_token)}`}
          download={`punchy-tag-${info.merchant.slug || info.merchant.id}.svg`}
          className="px-3 py-2 rounded-md border border-neutral-300 text-sm"
        >
          Download SVG
        </a>
      </div>
    </div>
  );
}
